/**
 * Funnel Layout Constants - MA-ARCH-161
 * 
 * Layout dimensions and spacing constants for funnel visualization.
 * Extracted for centralized configuration.
 */

// Node dimensions
export const NODE_WIDTH = 160;
export const NODE_HEIGHT = 44;
export const NODE_WIDTH_HOVERED = 260;
export const NODE_HEIGHT_HOVERED_MIN = 140; // Minimum height for styling only

// Spacing
export const HORIZONTAL_GAP = 40;
export const VERTICAL_GAP = 80;

// MA-UI-129: DOM-based hover clearance constants
export const HOVER_UPWARD_SHIFT = 8; // Card shifts up by this amount when hovered
export const CLEARANCE_BUFFER = 20; // Buffer for comfortable cursor movement

// MA-UI-130: Connector offset constants
export const CONNECTOR_BORDER_OFFSET = 6; // Base offset for border/corners
export const CONNECTOR_SELECTION_RING_OFFSET = -3; // Offset for selected node ring
export const CONNECTOR_NON_HIGHLIGHTED_OFFSET = -5; // Non-highlighted edges
export const CONNECTOR_HOVER_BORDER_OFFSET = -7; // Hovered cards

/**
 * Calculate the effective connector offset based on node state.
 * @param {Object} options - Node state options
 * @returns {number} - The offset value
 */
export function getConnectorOffset({
  isSourceHovered = false,
  isSourceSelected = false,
  isHighlighted = false,
}) {
  if (isSourceHovered) {
    return CONNECTOR_HOVER_BORDER_OFFSET;
  }
  if (isSourceSelected) {
    return CONNECTOR_SELECTION_RING_OFFSET;
  }
  if (!isHighlighted) {
    return CONNECTOR_NON_HIGHLIGHTED_OFFSET;
  }
  return CONNECTOR_BORDER_OFFSET;
}

/**
 * Calculate node position for visualization.
 * @param {number} depth - The node depth in the tree
 * @param {number} index - The node index at this depth
 * @param {number} siblingCount - Number of siblings at this depth
 * @returns {{x: number, y: number}} - The position
 */
export function calculateNodePosition(depth, index, siblingCount) {
  const x = depth * (NODE_WIDTH + HORIZONTAL_GAP);
  
  // Center siblings vertically
  const totalHeight = siblingCount * NODE_HEIGHT + (siblingCount - 1) * VERTICAL_GAP;
  const startY = -totalHeight / 2;
  const y = startY + index * (NODE_HEIGHT + VERTICAL_GAP);
  
  return { x, y };
}

export default {
  NODE_WIDTH,
  NODE_HEIGHT,
  NODE_WIDTH_HOVERED,
  NODE_HEIGHT_HOVERED_MIN,
  HORIZONTAL_GAP,
  VERTICAL_GAP,
  HOVER_UPWARD_SHIFT,
  CLEARANCE_BUFFER,
  CONNECTOR_BORDER_OFFSET,
  CONNECTOR_SELECTION_RING_OFFSET,
  CONNECTOR_NON_HIGHLIGHTED_OFFSET,
  CONNECTOR_HOVER_BORDER_OFFSET,
  getConnectorOffset,
  calculateNodePosition,
};
